import { Stack, Typography, IconButton } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';
//
import Iconify from './Iconify';
import { formatAddress } from '@/utils/formatAddress';
//
type AddressProps = {
  formatted_address: string;
  postcode?: string;
  hideGoogleMapsButton?: boolean;
  maxLines?: number;
};

export default function AddressWithGoogleMapsIconButton({
  formatted_address,
  postcode,
  hideGoogleMapsButton = false,
  maxLines,
}: AddressProps) {
  const { formattedAddress, formattedAddressWithPostcode, googleMapsAddress } =
    formatAddress(formatted_address, postcode);
  const addressToDisplay = postcode
    ? formattedAddressWithPostcode
    : formattedAddress;
  const plainAddress = addressToDisplay
    .replace(/<[^>]*>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
  const shouldClampAddress = Boolean(maxLines && maxLines > 0);
  const clampedAddressSx: SxProps<Theme> = shouldClampAddress
    ? {
        display: '-webkit-box',
        WebkitBoxOrient: 'vertical' as const,
        WebkitLineClamp: maxLines,
        overflow: 'hidden',
        whiteSpace: 'normal',
      }
    : {};

  return (
    <Stack direction="row" sx={{ minWidth: 0 }}>
      <Typography
        variant="body2"
        title={plainAddress}
        sx={{
          mt: shouldClampAddress ? 0 : 1,
          mb: shouldClampAddress ? 0 : 0.5,
          minWidth: 0,
          whiteSpace: 'pre-line',
          ...clampedAddressSx,
        }}
        dangerouslySetInnerHTML={{
          __html: addressToDisplay,
        }}
      />
      {!hideGoogleMapsButton && (
        <IconButton
          size="small"
          href={`https://www.google.com/maps/search/${googleMapsAddress}`}
          target="_blank"
          rel="noopener noreferrer"
          color="info"
          sx={{ alignSelf: 'flex-start', mt: shouldClampAddress ? -0.5 : 0.5 }}
        >
          <Iconify icon="eva:pin-outline" />
        </IconButton>
      )}
    </Stack>
  );
}
